import checks from './lib/checks';
import clones from './lib/clones';
import generators from './lib/generators';
import mutators from './lib/mutators';

export default {
	...checks,
	...clones,
	...generators,
	...mutators
};
